import React from 'react';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import ViewNumberBlock from './Block/ViewBlock';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';

/* STYLE */
import '@redturtle/volto-rt-blocks/components/Blocks/Numbers/Numbers.less';

const View = ({ data }) => {
  return (
    <div
      className={cx('block numbers full-width', {
        ['has--bg--' + data.bg]: data.bg,
      })}>
      <Container>
        <div className="numbers-wrapper">
          <div className="numbers-header">
            {data?.title && (
              <div className="numbers-title">
                <h2>{data.title}</h2>
              </div>
            )}
            {data?.description && (
              <div className="numbers-description">
                <TextBlockView data={{ value: data?.description ?? {} }} />
              </div>
            )}
          </div>
          <div className="numbers-wrapper-cards">
            {data?.numbers?.map((numberBlock, i) => (
              <ViewNumberBlock data={numberBlock} key={i} />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default View;
